// 大屏数据模块
const state = {
  // 大屏数据
  screenData: {},
  // 征订数据（原始接口返回值）
  orderData: {},
  // 征订季次列表
  seasons: [],
  // 当前选中季次ID
  selectedSeasonId: null
}

const mutations = {
  // 设置大屏全部数据
  SET_SCREEN_DATA(state, data) {
    state.screenData = data
  },
  // 设置征订数据
  SET_ORDER_DATA(state, data) {
    state.orderData = data
  },
  // 设置季次列表
  SET_SEASONS(state, seasons) {
    state.seasons = Array.isArray(seasons) ? seasons : []
  },
  // 设置当前季次
  SET_SELECTED_SEASON(state, seasonId) {
    state.selectedSeasonId = seasonId
  },
  // 重置大屏数据
  RESET_SCREEN(state) {
    state.screenData = {}
    state.orderData = {}
    state.seasons = []
    state.selectedSeasonId = null
  }
}

const actions = {
  // 获取大屏数据
  async fetchBigScreenData({ commit, rootState }, { region } = {}) {
    try {
      let response
      
      // 根据区域参数决定使用哪个API
      if (region && region.trim()) {
        // 市级地图：传入城市名称参数
        response = await this._vm.$api.getScreenDataToV2(region.trim())
      } else {
        // 省级地图：不传参数
        response = await this._vm.$api.getScreenDataToV2()
      }
      
      // 规范化单品排行相关字段为数组
      const normalizeArray = (val) => {
        if (Array.isArray(val)) return val
        if (val && typeof val === 'object') return [val]
        return []
      }
      const normalized = {
        ...response,
        danpin_xiaoshou_week: normalizeArray(response?.danpin_xiaoshou_week),
        danpin_xiaoshou_month: normalizeArray(response?.danpin_xiaoshou_month),
        danpin_xiaoshou_halfyear: normalizeArray(response?.danpin_xiaoshou_halfyear)
      }
      commit('SET_SCREEN_DATA', normalized)
    } catch (error) {
      console.error('获取大屏数据失败:', error)
    }
  },
  // 获取征订数据并分发到各个子模块
  async fetchOrderData({ commit, state, dispatch }) {
    try {
      const response = await this._vm.$api.getOrderData()
      commit('SET_ORDER_DATA', response)
      
      // 分发数据到各个子模块
      if (response) {
        // 季次列表（最近3个季次）
        const seasons = response['999']?.seasons || []
        commit('SET_SEASONS', seasons)

        // 默认选择第一个季次（若当前选择无效）
        const defaultSeasonId = seasons[0]?.id ?? null
        const seasonIdList = seasons.map(s => s.id)
        const currentSeasonId = seasonIdList.includes(state.selectedSeasonId)
          ? state.selectedSeasonId
          : defaultSeasonId
        commit('SET_SELECTED_SEASON', currentSeasonId)

        // 左侧季次相关模块（1、2、3）
        await dispatch('applySeasonData', { seasonId: currentSeasonId })

        // 模块4：全省今日征订概况
        if (response['4']) {
          commit('keyMetrics/SET_DATA', response['4'], { root: true })
        }
        
        // 模块5：全省征订数据趋势
        if (response['5']) {
          commit('provinceTrend/SET_DATA', response['5'], { root: true })
        }
        
        // 模块6：今日概况
        if (response['6']) {
          commit('todayOverview/SET_DATA', response['6'], { root: true })
        }
        
        // 模块7：各市州今日征订码洋占比
        if (response['7']?.data) {
          commit('cityAmountShare/SET_DATA', response['7'].data, { root: true })
        }
        
        // 模块8：各市州今日征订数据对比
        if (response['8']?.data) {
          commit('cityChannelCompare/SET_DATA', response['8'].data, { root: true })
        }
      }
      
      return response
    } catch (error) {
      console.error('获取征订数据失败:', error)
      throw error
    }
  },
  // 切换季次并应用到左侧模块
  applySeasonData({ commit, state }, { seasonId } = {}) {
    const data = state.orderData
    if (!data) return

    const seasonKey = seasonId != null ? String(seasonId) : null

    // 模块1：全省征订覆盖率
    const module1 = data['1'] || {}
    const m1Season = seasonKey && module1.seasonData?.[seasonKey]
    commit('provinceCoverage/SET_DATA', m1Season && Object.keys(m1Season).length ? m1Season : module1, { root: true })

    // 模块2：各市州征订覆盖率
    const module2 = data['2'] || {}
    const m2List = (seasonKey && module2.seasonData?.[seasonKey]?.data) || module2.data || []
    commit('cityCoverage/SET_DATA', m2List, { root: true })

    // 模块3：分类商品码洋对比
    const module3 = data['3'] || {}
    const m3List = (seasonKey && module3.seasonData?.[seasonKey]?.data) || module3.data || []
    commit('categoryAmount/SET_DATA', m3List, { root: true })
  },
  // 外部选择季次
  selectSeason({ commit, dispatch }, seasonId) {
    commit('SET_SELECTED_SEASON', seasonId)
    dispatch('applySeasonData', { seasonId })
  }
}

const getters = {
  screenData: state => state.screenData,
  orderData: state => state.orderData,
  seasons: state => state.seasons,
  selectedSeasonId: state => state.selectedSeasonId
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
